export const notificationStatus = [
    'Diterima dari Otoritas Asal B3',
    'Verifikasi Administrasi dan Teknis',
    'Kirim Surat Kebenaran Impor ke Importir',
    'Tunggu Respon',
    'Ada Rencana Import',
    'Tidak Ada Import',
    'Selesai',
    'Dibatalkan'
]